(function () {
  var STORAGE_KEY = 'maison1822_favorites';

  function getAll() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function save(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    updateBadges();
    updateButtons();
    document.dispatchEvent(new CustomEvent('favorites:updated', { detail: { list: list } }));
  }

  function has(sku) {
    return getAll().some(function (i) { return i.sku === sku; });
  }

  function add(item) {
    var list = getAll();
    if (!list.some(function (i) { return i.sku === item.sku; })) {
      list.push(item);
      save(list);
    }
    return list;
  }

  function remove(sku) {
    var list = getAll().filter(function (i) { return i.sku !== sku; });
    save(list);
    return list;
  }

  function toggle(item) {
    if (has(item.sku)) {
      remove(item.sku);
    } else {
      add(item);
    }
  }

  function updateBadges() {
    var count = getAll().length;
    document.querySelectorAll('[data-favorites-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function updateButtons() {
    document.querySelectorAll('[data-favorites-toggle]').forEach(function (btn) {
      var sku = btn.dataset.sku;
      var labelEl = btn.querySelector('[data-favorites-toggle-label]');
      var isFav = has(sku);
      btn.classList.toggle('is-favorite', isFav);
      if (labelEl) {
        labelEl.textContent = isFav ? btn.dataset.removeLabel : btn.dataset.addLabel;
      }
    });
  }

  window.FavoritesList = { getAll: getAll, add: add, remove: remove, toggle: toggle, has: has };

  document.addEventListener('DOMContentLoaded', function () {
    updateBadges();
    updateButtons();
  });

  document.addEventListener('on:variant:change', updateButtons);

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-favorites-toggle]');
    if (!btn) return;
    evt.preventDefault();
    toggle({
      title: btn.dataset.productTitle,
      variant: btn.dataset.variantTitle,
      sku: btn.dataset.sku,
      url: btn.dataset.productUrl
    });
  });
})();
